import React from 'react';
import { WTitle } from '../../components/Widget';
import VideoTranscript from '../../components/VideoTranscript/index';
import FooterBg from '../../../../../../assets/education/topic1000/section1_footer_bg.png';
import Person from '../../../../../../assets/education/topic1000/Interacting1.png';
import Light from '../../../../../../assets/education/topic1000/Interacting2.png';
import useIntersectionObserver from '../../../../../../hooks/useIntersectionObserver';
import { useParams } from 'react-router-dom';
import { useStore } from '../../../../store';
interface ISection0Props {
  settings: any;
}

const Section0: React.FunctionComponent<ISection0Props> = ({ settings }) => {
  const ID = '1';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const paragraphsSettings = React.useMemo(
    () => settings?.paragraphs[0],
    [settings?.paragraphs]
  );
  const { updateParagraphState } = useStore();
  const { targetRef, isVisible } = useIntersectionObserver({
    threshold: 0.1, // 元素 30% 进入视口时触发
    rootMargin: '-50px', // 根边距缩小 50px（需元素进入视口 50px 后才判定）
  });
  React.useEffect(() => {
    if (isVisible) {
      updateParagraphState(p_course, p_topic, ID, 'completed', []);
    }
  }, [isVisible]);
  React.useEffect(() => {
    const onPlay = () => {
      if (process.env.REACT_APP_HOST_TYPE === 'dev') {
        return;
      }
      const elem = document?.querySelector('#video1600');
      if (elem?.requestFullscreen) {
        try {
          elem.requestFullscreen();
        } catch (error) {
          console.log(error);
        }
        document
          ?.querySelector('#video1600')
          ?.removeEventListener('play', onPlay);
      }
    };
    document?.querySelector('#video1600')?.removeEventListener('play', onPlay);
    document
      ?.querySelector('#video1600')
      ?.addEventListener('play', onPlay, { passive: true });
    return () =>
      document
        ?.querySelector('#video1600')
        ?.removeEventListener('play', onPlay);
  }, []);

  return (
    <div className="course-landing">
      <div className="course-landing-content">
        <div className="course-landing-text">
          <WTitle title={paragraphsSettings.header}></WTitle>
          <img className="person" src={Person} alt="" />
          <div className="course-box">
            <div className="video-container">
              <video
                id="video1400"
                width="100%"
                controls
                autoPlay={process.env.REACT_APP_HOST_TYPE !== 'dev'}
              >
                <source
                  src={paragraphsSettings?.landingVideo?.src}
                  type="video/mp4"
                />
                Your browser does not support HTML video.
              </video>
              <VideoTranscript transcripts={paragraphsSettings.transcripts} />
            </div>
            <img className="light" src={Light} alt="" />
          </div>
        </div>
      </div>
      <div className="content" ref={targetRef}>
        {isVisible && (
          <div className="text">
            <span className=" text-focus-in">
              {paragraphsSettings.description}
            </span>
          </div>
        )}
      </div>
      <div className="footer-bg">
        <img src={FooterBg} alt="" />
      </div>
    </div>
  );
};

export default Section0;
